import React, { useState } from "react"
import { CONSTANTS } from "@data"
import { CloseButton } from "@shared"
import { css } from "@jsUtils"
import { VideoURL, VideoYouTube, VideoVimeo } from "@components/sections"
import { PageSection } from "../PageSection"
import Styles from "./videoOverlay.module.scss"

const { THEMES } = CONSTANTS

const typesOfVideoSizes = { md: Styles.sizeMD, xl: Styles.sizeXL }

const VideoOverlay = props => {
  const { onClose, youTubeId, videoURL, vimeoId, size = "md" } = props
  const videoSize = typesOfVideoSizes[size]
  const [ready, setReady] = useState(false)

  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready)}
      theme={THEMES.DARK}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <div className={css(Styles.vidWrapper, videoSize)}>
        {youTubeId && <VideoYouTube youTubeId={youTubeId} />}
        {vimeoId && <VideoVimeo vimeoId={vimeoId} />}
        {videoURL && <VideoURL src={videoURL} />}
      </div>
      <CloseButton tabbing={0} onClose={onClose} ariaExpanded ariaLabel="Close" />
    </PageSection>
  )
}

export default VideoOverlay
